

export const notificationNavigateDashboard = (notification, history) => {
    const status = notification.task.status === 'doing' ?
        notification.task.moment.currentStatus : notification.task.status
    const query = new URLSearchParams({ taskId: notification.task.taskId, status: status })
    history.push(`/tasks?${query}`, { notification: notification._id })
};
export const notificationNavigatePane = (notification, history) => {

    const query = new URLSearchParams({ flowId: notification.flow.flowId })
    history.push(`/workflow/?${query}`, { notification: notification._id, taskId: notification.task.taskId })

};
